<template>
    <div class="KeikakuStylenumberEntry">
        <div class="KeikakuStylenumber">
            {{ ProductData.productCode + ProductType}}
        </div>
        <KeikakumeisaiHanbaisaki v-for="entry in ProductData.Data" :key="entry.hanbaisaki" :-HanbaisakiInfo="entry" />
    </div>
</template>

<script>
import KeikakumeisaiHanbaisaki from './KeikakumeisaiHanbaisaki.vue'

export default{
    components:{
        KeikakumeisaiHanbaisaki,
    },
    computed:{
        ProductType()
        {
            const lastChar = this.ProductData.productCode[this.ProductData.productCode.length - 1];
            switch(lastChar)
            {
                case 'R': return '（限定版）';
                case 'T': return '（一般版）';
                case 'P': return '（PLEX/PB）';
                default: return '';
            }
        }
    },
    props:{
        ProductData: Object
    },
}
</script>

<style>
.KeikakuStylenumber
{
    font-weight: bold;
    margin-bottom: 8px;
}

.KeikakuStylenumberEntry + .KeikakuStylenumberEntry
{
    margin-top: 25px;
}
</style>